export default __webpack_public_path__ + "static/media/bean-logo2.53b5463f.webp";